import React from 'react';
import PropTypes from 'prop-types';
import OverlayFooter from 'components/OverlayFooter';
import Style from './ForgotPassword.module.scss';
import Header from '../../../Header';

const emailInstructions = 'Check your email for instructions on how to reset your password.';
const backText = 'Back to Sign In';

const ForgotPassword = ({
  email,
  existingUserPage,
  headerProps,
  landingPage,
  language,
  setScreen,
}) => (
  <div className={Style.ForgotPassword}>
    <Header {...headerProps} />
    <div className={Style.signInWrap}>
      <h1>{email}</h1>
      <div className={Style.instructions}>{emailInstructions}</div>
      <button
        className={Style.btnPrimary}
        onClick={() => {
          setScreen({ current: existingUserPage, prev: landingPage });
        }}
      >
        {backText}
      </button>
    </div>
    <OverlayFooter language={language} />
  </div>
);

export default ForgotPassword;

ForgotPassword.propTypes = {
  email: PropTypes.string,
  existingUserPage: PropTypes.string,
  headerProps: PropTypes.shape({}),
  landingPage: PropTypes.string,
  language: PropTypes.shape({}).isRequired,
  setScreen: PropTypes.func,
};
